import { useCallback } from 'react';
import { useAttachmentsUploadStore } from '../attachments-upload-store-provider';
import { AttachmentsPanelType } from '../types';
import { AttachmentUpload } from '../attachments-upload-store';

export function useAttachmentsUploadStatus(entityId: number, entityType: AttachmentsPanelType) {
    const uploadStore = useAttachmentsUploadStore();

    const uploads = uploadStore.getUploadsForEntity(entityId, entityType);
    const activeUploads = uploads.filter(
        (upload) => upload.status === 'uploading' || upload.status === 'processing'
    );

    const getUploadProgress = useCallback(
        (fileServerFileId: string) => uploadStore.getUploadProgressPercentage(fileServerFileId),
        [uploadStore]
    );

    const removeFailedUpload = useCallback(
        (upload: AttachmentUpload) => {
            if (upload.status === 'failed') {
                uploadStore.removeUpload(upload.id);
            }
        },
        [uploadStore]
    );

    return {
        uploads,
        activeUploads,
        hasActiveUploads: activeUploads.length > 0,
        getUploadProgress,
        removeFailedUpload,
    };
}
